<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="CustCreditTableRef" :fields="fields" :title="table_title.title1"
        :show_query_container="true" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="false" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" :isBusy="isBusy" @on_query="on_query" @state_change="state_change"
        :show_toolbar_button="[0, 0, 0, 0, 0]" @current_changed="current_changed" @tool_invoke="tool_invoke">
        <template #query>
          {{ $t("common.customer") + $t("common.num") }}：<el-input clearable size="small" style="width: 120px"
            v-model="accountNum"></el-input>
        </template>
      </TableMain>
      <!-- <template #table2>
        <el-card class="box-card" style="height: 100%" shadow="always">
          <div class="mb-1">
            <i class="iconfont icon-details" style="font-size: 16px"
              ><span class="ml-1" style="font-size: 14px"
                ><strong>操作详情</strong></span
              ></i
            >
          </div>
          <div class="mb-4">
            <span class="ml-1 text-danger" style="font-size: 14px"
              ><strong>{{ codeType }}</strong></span
            >
          </div>

          <div v-for="(item, key) in Details" :key="key" class="text item">
            <el-row :gutter="10" class="mb-3">
              <el-col :span="4" class="ml-4"
                ><div>
                  <span class="col-3"
                    ><strong>{{ getLabel(key) }} : </strong></span
                  >
                </div></el-col
              >
              <el-col :span="6"
                ><div>
                  <span>{{ item }}</span>
                </div></el-col
              >
            </el-row>
            <div class="mb-3"></div>
          </div>
        </el-card>
      </template> -->
    </BaseContainer>
  </div>
</template>

<script>
import * as CustomerCreditLogController from "../../controllers/fi/CustomerCreditLogController"
import BaseContainer from "../components/BaseContainer"
import TestQueryPanel from "../components/base/TestQueryPanel"
import SplitContainer2 from "../components/container/SplitContainer2"
import BaseModal from "../components/modals/baseModal"
import TableMain from "../components/table/TableMain"

export default {
  name: "CreditLog",
  components: {
    BaseContainer,
    TableMain,
    BaseModal,
    TestQueryPanel,
    SplitContainer2,
  },
  data() {
    return {
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_customer_credit_log"
      },
      fields: CustomerCreditLogController.fields,
      fields_detail: CustomerCreditLogController.fields_detail,
      dataForm: _.cloneDeep(CustomerCreditLogController.dataForm),
      rules: CustomerCreditLogController.rules,
      isBusy: false,
      isBusy1: false,
      Details: {},
      codeType: "",
      accountNum: "",
    }
  },
  created() { },
  methods: {
    getLabel(key) {
      return _.find(this.fields_detail, { key: key }).label
    },
    async current_changed(old, current) {
    },
    //#region 查询
    async on_query(set_data, date_range) {
      let _this = this
      this.Details = {}
      this.codeType = ""
      this.isBusy = true
      let _params = {}

      if (!_.isNull(date_range[0])) {
        _params.fromDate = this.$date.format(
          new Date(date_range[0]),
          "yyyy-MM-dd"
        )
      }
      if (!_.isNull(date_range[1])) {
        _params.toDate = this.$date.format(
          new Date(date_range[1]),
          "yyyy-MM-dd"
        )
      }
      if (this.accountNum != "") {
        _params.accountNum = this.accountNum
      }

      set_data([])
      let _result = await CustomerCreditLogController.methods.getData(_params)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        let data = _result[0]
        if (data.length > 0) {
          _.each(data, (t) => {
            let json = JSON.parse(t.data)
            t.AccountNum = json.AccountNum
            let __index = _.findIndex(
              _this.$store.state.biz_data.baseData.Customer,
              {
                AccountNum: t.AccountNum,
              }
            )
            if (__index > -1) {
              t.SEI_Name =
                _this.$store.state.biz_data.baseData.Customer[__index].SEI_Name
            }
            t.CreditMax = json.CreditMax
            t.FromDate = json.FromDate
            t.ToDate = json.ToDate
            t.code =
              t.code == "splant_customer_credit" ? this.$t("common.customer_credit") : this.$t("common.customer_credit_temp")
            switch (t.action) {
              case "a":
                t.action = this.$t("common.add")
                break
              case "u":
                t.action = this.$t("common.edite")
                break
              case "d":
                t.action = this.$t("common.delete")
                break
              case "i":
                t.action = this.$t("common.add")
                break
              case "s":
                t.action = this.$t("common.query")
                break
              case "r":
                t.action = this.$t("common.move")
                break
              default:
                break
            }
          })
          set_data(data)
        }
      }

      this.isBusy = false
    },
    //#endregion

    //#region 保存
    //#endregion

    //#region 状态切换
    // state_change(data, cb) {

    // },
    //#endregion

    //#region 打印导出
    // tool_invoke(data, cb) {

    // },
    //#endregion
  },
}
</script>
